import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { enUS, zhTW } from './utils/languages';
import { storageKeys } from './utils/constants';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': { translation: enUS },
      'zh-TW': { translation: zhTW },
    },
    lng: localStorage.getItem(storageKeys.language) || 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
